import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';
import api from '../../services/api';
import './style.css';
import { Options, Select } from '../../components/Select';
import errorIcon from '../../img/icon/Error.svg';

export function ResponsavelCadastrar() {
    const [isLoading, setIsLoading] = useState(true);

    {/* Informações Gerais */ }
    const [nome, setNome] = useState("");
    const [tipoDocumento, setTipoDocumento] = useState("");
    const [numeroDocumento, setNumeroDocumento] = useState("");
    const [especialidade, setEspecialidade] = useState("");
    const [cargo, setCargo] = useState("");
    const [email, setEmail] = useState("");
    const [telefone, setTelefone] = useState("");
    const [celular, setCelular] = useState("");
    const [senha, setSenha] = useState("");
    const [confirmarSenha, setConfirmarSenha] = useState("");

    {/* Informações Residenciais */ }
    const [cep, setCep] = useState('');
    const [endereco, setEndereco] = useState('');
    const [numero, setNumero] = useState('');
    const [bairro, setBairro] = useState('');
    const [complemento, setComplemento] = useState('');
    const [estado, setEstado] = useState('');
    const [cidade, setCidade] = useState('');
    const [obs, setobs] = useState('');

    const [responsaveis, setResponsaveis] = useState([]);
    const [responsavelSelecionado, setResponsavelSelecionado] = useState(null);
    const [idResponsavel, setResponsavelId] = useState(null);

    const [error, setError] = useState("");

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const inputRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });


    const handleSelectTipoDocumento = (documento: any) => {
        setTipoDocumento(documento);
    };

    const validateForm = () => {
        if (!email) {
            setError("Por favor, insira um e-mail.");
            return false;
        }
        if (!email.includes('@')) {
            setError("Por favor, insira um e-mail válido.");
            return false;
        }
        if (!nome) {
            setError("Por favor, insira um nome.")
            return false;
        }
        if (tipoDocumento == undefined) {
            setError("Por favor, selecione um tipo de documento.");
            return false;
        }
        if (!numeroDocumento) {
            setError("Por favor, selecione o número do documento.")
            return false;
        }
        if (!especialidade) {
            setError("Por favor, insira uma especialidade.");
            return false;
        }
        if (!cargo) {
            setError("Por favor, insira um cargo.");
            return false;
        }
        if (!celular) {
            setError("Por favor, insira um celular.")
            return false
        }
        if (!senha) {
            setError("Por favor, insira uma senha.");
            return false;
        }
        if (!confirmarSenha) {
            setError("Por favor, repita a senha.");
            return false;
        }
        if (senha !== confirmarSenha) {
            setError("As senhas não estão iguais.");
            return false;
        }
        setError("");
        return true;
    }

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (!validateForm()) return;

        try {
            setIsLoading(true)
            const userData = {
                nome: nome,
                tipo_profissional: tipoDocumento,
                registro_profissional: numeroDocumento,
                especialidade: especialidade,
                cargo: cargo,
                email: email,
                telefone: telefone,
                celular: celular,
                password: senha
            }
            const response = await api.post('register/responsavel', userData);

            if (response.data.data === 'Já existe um usuário cadastrado com o e-mail fornecido') {
                setIsLoading(false)
                setAlert({ message: 'E-MAIL já cadastrado!', variant: 'danger', show: true });
                return;
            }

            if (response.status === 200) {
                setIsLoading(false)
                setNome('');
                setTipoDocumento('');
                setNumeroDocumento('');
                setEspecialidade('');
                setCargo('');
                setEmail('');
                setTelefone('');
                setCelular('');
                setSenha('');
                setConfirmarSenha('');
                setAlert({ message: 'Responsável cadastrado', variant: 'success', show: true });
            }

        } catch (error) {
            setError("Erro ao enviar os dados. Tente novamente mais tarde.");
            console.error('Erro no registro:', error);
        } finally {
            setIsLoading(false)
        }
    };


    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Cadastro do Responsável</h3>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Responsável *' htmlFor="nome" />
                                <input
                                    type="text"
                                    id="nome"
                                    placeholder="Digite o Nome do Responsável"
                                    value={nome}
                                    onChange={(e) => {
                                        setNome(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Tipo de documento *' htmlFor="tipo_documento" />
                                <Select id="selectDocumento" onSelect={handleSelectTipoDocumento}>
                                    <Options key='CRM' value='CRM' name='CRM' />
                                    <Options key='OUTRO' value='OUTRO' name='OUTRO' />
                                </Select>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Número do Documento *' htmlFor="numero_documento" />
                                <InputMask
                                    ref={inputRef}
                                    value={numeroDocumento}
                                    onChange={(e: any) => setNumeroDocumento(e.target.value)}
                                    placeholder="Digite o Número do Documento"
                                    className="form-control"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={4}>
                            <FormGroup>
                                <Label title='Especialidade *' htmlFor="especialidade" />
                                <InputMask
                                    ref={inputRef}
                                    value={especialidade}
                                    onChange={(e: any) => setEspecialidade(e.target.value)}
                                    placeholder="Digite a Especialidade"
                                    className="form-control"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={4}>
                            <FormGroup>
                                <Label title='Cargo' htmlFor="cargo" />
                                <InputMask
                                    ref={inputRef}
                                    id='cargo'
                                    value={cargo}
                                    onChange={(e: any) => setCargo(e.target.value)}
                                    placeholder="Digite o Cargo"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={4}>
                            <FormGroup>
                                <Label title='Email *' htmlFor="email" />
                                <InputMask
                                    ref={inputRef}
                                    id='email'
                                    value={email}
                                    onChange={(e: any) => setEmail(e.target.value)}
                                    placeholder="Digite o Email"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Telefone' htmlFor="telefone" />
                                <InputMask
                                    ref={inputRef}
                                    mask="(99) 99999-9999"
                                    value={telefone}
                                    onChange={(e: any) => setTelefone(e.target.value)}
                                    placeholder="(__) _____-____"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={6}>
                            <FormGroup>
                                <Label title='Celular *' htmlFor="celular" />
                                <InputMask
                                    ref={inputRef}
                                    mask="(99) 99999-9999"
                                    value={celular}
                                    onChange={(e: any) => setCelular(e.target.value)}
                                    placeholder="(__) _____-____"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Senha *' htmlFor="senha" />
                                <InputMask
                                    ref={inputRef}
                                    type="password"
                                    id="senha"
                                    placeholder="Digite a Senha"
                                    value={senha}
                                    style={{ width: '100%' }}
                                    onChange={(e: any) => setSenha(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Confirmar Senha *' htmlFor="confirmar_senha" />
                                <InputMask
                                    ref={inputRef}
                                    type="password"
                                    id="confirmarSenha"
                                    placeholder="Digite a Senha Novamente"
                                    value={confirmarSenha}
                                    style={{ width: '100%' }}
                                    onChange={(e: any) => setConfirmarSenha(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Button className="btn-main mt-4" type="submit" onClick={handleSubmit}>Inserir Responsável</Button>
                </Form>
            </Main>
            {error && (
                <div className="error-container my-3 text-danger">
                    <img
                        className="error-icon"
                        src={errorIcon}
                        alt="Error" />
                    <p className="error-text text-center mb-3">{error}</p>
                </div>
            )}
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
